<template>
    <tr>
        <!-- <td> -> Supprimé par Noëlle
            <oss-date-picker
                v-model="line.date"
                :filterWithoutClosedAccountingPeriods="true"
                hide-details
                :textFieldReadOnly="false"
                :disabled="line.isBankTransaction"
                dense
                :readonly="readonly || !!line.tag"
                :prefixDataCy="'AccountingItemEdition-item-' + index"
                :tabindex="TAB_INDEX_OFFSET * index + 1"
            ></oss-date-picker>
        </td> -->
        <td :width="onAccountingLinesPage && '20%'">
            <AccountableAccount
                v-model="accountableAccount"
                :inAccountableAccounts="accountableAccounts"
                :thirdParty="line.thirdPartyCompany || line.user || line.bankAccount"
                :show-validation="false"
                :hide-details="true"
                outlined
                :company-id="company.id"
                :edit-sub-accountable-account="false"
                label="Compte comptable"
                :editAccountableAccount="true"
                :embeddedInput="true"
                :defineThirdParty="true"
                :readonly="readonly"
                :disabled="line.isBankTransaction || !!line.tag"
                :addInvoiceProduct="enableStock"
                :tabindex="!onAccountingLinesPage && TAB_INDEX_OFFSET * index + 2"
                :id="'line-aa-' + index"
                showDescription="true"
                ref="accountableAccount"
                :onAccountingLinesPage="onAccountingLinesPage"
                @focus-on-date-or-wording="focusOnDateOrWording"
            >
                <template v-slot:activator="{ props, accountableAccountName }">
                    <v-text-field
                        hide-details
                        readonly
                        :data-cy="'accountingItemEdition-item-' + index + '-accountableAccount'"
                        v-bind="props"
                        @update:focused="onAAFocus($event, props.onClick)"
                        :tabindex="
                            onAccountingLinesPage
                                ? (editionIndex + 1) * 100 + (index + 1) * 10 + 1
                                : TAB_INDEX_OFFSET * index + 1
                        "
                        :model-value="accountableAccountName"
                    />
                </template>
            </AccountableAccount>
        </td>
        <td :width="onAccountingLinesPage && '20%'">
            <div>
                <v-text-field
                    v-model="line.wording"
                    @change="onItemWordingChanged()"
                    @focus="onFocus('wording')"
                    hide-details
                    outlined
                    :placeholder="defaultWording"
                    :readonly="readonly || !!line.tag"
                    :prefixDataCy="'AccountingItemEdition-item-' + index"
                    :tabindex="
                        onAccountingLinesPage
                            ? (editionIndex + 1) * 100 + (index + 1) * 10 + 3
                            : TAB_INDEX_OFFSET * index + 2
                    "
                    density="compact"
                />
            </div>
            <div class="mb-2 px-2" v-if="displayFreeTag">
                <FreeTag
                    :inPrimaryLog="'XXXXXX'"
                    :companyTags="companyTags"
                    :company="company"
                    :documentType="type"
                    :accountingLine="line"
                    @onTagsChanged="onAccountingLineTagsChanged($event)"
                />
            </div>
        </td>
        <td v-if="addQuantityColumn">
            <span v-if="line.stockOperation && line.stockOperation.stockProduct">{{
                line.stockOperation.stockProduct.title
            }}</span>
        </td>
        <td v-if="addQuantityColumn">
            <oss-text-field
                :hide-details="true"
                @focus="onFocus('productQuantity')"
                single-line
                dense
                outlined
                :readonly="readonly"
                v-if="line.stockOperation && line.stockOperation.stockProduct"
                :rules="[(v) => v > 0 || $t('settings.positiveNumber')]"
                :data-cy="'AccountingItemEdition-item-' + index + '-productQuantity'"
                v-model="line.stockOperation.productQuantity"
            >
            </oss-text-field>
        </td>
        <td v-if="additionalQuantityColumns">
            <div v-if="hasQuantities">
                <v-menu :close-on-content-click="false" offset-x left>
                    <template v-slot:activator="{ props }">
                        <v-btn variant="text" v-bind="props">
                            {{ line.stockOperation.data.quantities.length }}
                            <v-icon size="x-small" right> $oss-edit </v-icon>
                        </v-btn>
                    </template>
                    <v-list class="px-2">
                        <table class="oss-dense-table" width="100%">
                            <thead>
                                <tr>
                                    <th style="text-align: center" width="45%">Produit</th>
                                    <th style="text-align: center" width="55%">Quantité</th>
                                </tr>
                            </thead>
                            <tr
                                v-for="(item, index) in line.stockOperation.data.quantities"
                                :key="index"
                            >
                                <td style="text-align: center" width="45%">
                                    {{ item.quantityName }}
                                </td>
                                <td>
                                    <oss-text-field
                                        :hide-details="true"
                                        @focus="onFocus('productQuantity' + index)"
                                        single-line
                                        dense
                                        outlined
                                        :readonly="readonly"
                                        :rules="[(v) => v > 0 || $t('settings.positiveNumber')]"
                                        :data-cy="
                                            'AccountingItemEdition-item-' +
                                            index +
                                            '-productQuantity' +
                                            index
                                        "
                                        @click="console.log(line.stockOperation)"
                                        v-model="item.quantity"
                                    >
                                    </oss-text-field>
                                </td>
                            </tr>
                        </table>
                    </v-list>
                </v-menu>
            </div>
        </td>
        <td :width="onAccountingLinesPage && '20%'">
            <oss-text-field
                :hide-details="true"
                @focus="onFocus('debit')"
                suffix="&#x20ac;"
                @update:model-value="onItemDebitChanged"
                single-line
                dense
                outlined
                :readonly="readonly"
                :rules="[
                    (v) => (v !== '' && parseFloat(v) >= 0.0) || $t('settings.positiveNumber'),
                ]"
                :disabled="line.isBankTransaction || !!line.tag"
                :data-cy="'AccountingItemEdition-item-' + index + '-debit'"
                :tabindex="
                    onAccountingLinesPage
                        ? (editionIndex + 1) * 100 + (index + 1) * 10 + 3
                        : TAB_INDEX_OFFSET * index + 3
                "
                ref="debit"
                v-model="line.debit"
            />
        </td>
        <td :width="onAccountingLinesPage && '20%'">
            <oss-text-field
                :hide-details="true"
                @focus="onFocus('credit')"
                suffix="&#x20ac;"
                @update:model-value="onItemCreditChanged"
                single-line
                dense
                outlined
                :readonly="readonly"
                :rules="[
                    (v) => (v !== '' && parseFloat(v) >= 0.0) || $t('settings.positiveNumber'),
                ]"
                :disabled="line.isBankTransaction || !!line.tag"
                :data-cy="'AccountingItemEdition-item-' + index + '-credit'"
                :tabindex="
                    onAccountingLinesPage
                        ? (editionIndex + 1) * 100 + (index + 1) * 10 + 4
                        : TAB_INDEX_OFFSET * index + 4
                "
                @tab="onTabOnCredit"
                ref="credit"
                v-model="line.credit"
            />
        </td>
        <td v-if="showDueDateColumn && !onAccountingLinesPage">
            <!-- {{ line.dueDate }} -->
            <oss-date-picker
                v-if="!!line.paymentStatus"
                v-model="line.dueDate"
                @focus="onFocus('dueDate')"
                hide-details
                :textFieldClass="onAccountingLinesPage ? 'oss-light' : 'oss-dark'"
                :textFieldReadOnly="false"
                :disabled="line.isBankTransaction || !!line.tag"
                :notRequired="true"
                :no-menu="true"
                :outlined="false"
                :data-cy="'accountingItemEdition-item-' + index + '-dueDate'"
                :tabindex="!onAccountingLinesPage && TAB_INDEX_OFFSET * index + 5"
            >
            </oss-date-picker>
        </td>
        <td align="center" :width="onAccountingLinesPage && '20%'">
            <div class="d-flex justify-space-around align-center">
                <div>
                    <v-btn-icon
                        icon="$add"
                        size="small"
                        @click="insertLineAfter"
                        @focus="onFocus('addLine')"
                        :tabindex="TAB_INDEX_OFFSET * index + 5"
                        data-cy="Line-add"
                    />
                </div>
                <div>
                    <v-btn-icon
                        icon="$label_outline"
                        @click="displayFreeTag = !displayFreeTag"
                        @focus="onFocus('freeTag')"
                        size="small"
                    />
                </div>
                <v-btn-trash
                    @click="removeLine"
                    @focus="onFocus('removeLine')"
                    :tabindex="!onAccountingLinesPage && TAB_INDEX_OFFSET * index + 6"
                    size="small"
                    :disabled="disabledTrash"
                />
            </div>
        </td>
    </tr>
</template>

<script lang="ts">
import AccountableAccount from "@/views/AccountableAccount.vue";
import MultipleFreeTagging from "@/views/tag/MultipleFreeTagging.vue";
import FreeTag from "@/views/tag/FreeTag.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";
import { Emit } from "vue-facing-decorator";

@Component({
    components: {
        AccountableAccount,
        FreeTag,
        MultipleFreeTagging,
    },
    emits: [
        "focus-on-date",
        "focus-on-wording",
        "on-first-line-wording-change",
        "focus",
        "tab-on-credit",
        "previousLine",
        "nextLine",
        "accountableAccount-changed",
    ],
})
export class AccountingItemEditionLine extends Vue {
    @Model({}) line!: any;
    @Prop() type!: string;
    @Prop() readonly!: boolean;
    @Prop() index!: number;
    @Prop() defaultWording!: string;
    @Prop() company!: any;
    @Prop() enableStock!: boolean;
    @Prop() addQuantityColumn!: boolean;
    @Prop() additionalQuantityColumns!: boolean;
    @Prop() accountableAccounts!: any[];
    @Prop() companyTags!: any[];
    @Prop({ default: false }) showDueDateColumn!: boolean;
    @Prop({ default: false }) autoCompletion!: boolean;
    @Prop({ default: null }) focusedElement!: any;
    @Prop() editionIndex: number;
    @Prop({ default: false }) onAccountingLinesPage: boolean;
    @Prop({ default: false }) disabledTrash!: boolean;

    TAB_INDEX_OFFSET = 7;
    accoutableAccountIsFocused = false;

    displayFreeTag = false;

    get accountableAccount() {
        if (this.line.stockOperation?.stockProduct?.id) {
            return {
                ...this.line.accountableAccount,
                invoiceProduct: {
                    id: this.line.stockOperation.stockProduct.id,
                },
            };
        }
        return this.line.accountableAccount;
    }

    set accountableAccount(data) {
        this.line.accountableAccount = JSON.parse(JSON.stringify(data.accountableAccount));
        if (this.line.user) {
            this.line.user = null;
        }
        if (this.line.bankAccount) {
            this.line.bankAccount = null;
        }
        if (this.line.thirdPartyCompany) {
            this.line.thirdPartyCompany = null;
        }
        if (data.thirdParty) {
            switch (data.thirdParty.type) {
                case "company":
                    this.line.thirdPartyCompany = data.thirdParty;
                    delete this.line.thirdPartyCompany.type;
                    break;
                case "user":
                    this.line.user = data.thirdParty;
                    delete this.line.user.type;
                    break;
                case "bankAccount":
                    this.line.bankAccount = data.thirdParty;
                    delete this.line.bankAccount.type;
                    break;
            }
        }

        if (data.accountableAccount.invoiceProduct) {
            if (this.line.stockOperation) {
                this.line.stockOperation.stockProduct = data.accountableAccount.invoiceProduct;
                this.line.stockOperation.tagId =
                    data.accountableAccount.invoiceProduct.tag?.id || undefined;
            } else {
                this.line.stockOperation = {
                    stockProduct: data.accountableAccount.invoiceProduct,
                    productQuantity: 0,
                    tagId: data.accountableAccount.invoiceProduct.tag?.id || undefined,
                    data: { quantities: [] },
                };
            }
            if (data.accountableAccount.invoiceProduct.data?.quantities?.length) {
                this.line.stockOperation.data.quantities =
                    data.accountableAccount.invoiceProduct.data.quantities.map((q) => ({
                        quantityName: q.quantityName,
                        quantity: null,
                    }));
            }
        } else {
            this.line.stockOperation = null;
        }

        this.line.paymentStatus = this.getPaymentStatus();
        //
        // autoCompletion management
        //
        this.$emit("accountableAccount-changed");
        if (this.autoCompletion) {
            const self = this;
            setTimeout(() => {
                this.nextFocus();
            }, 500);
        }
    }

    get hasQuantities() {
        if (this.line.stockOperation?.data?.quantities?.length) {
            return true;
        }
        return false;
    }

    getPaymentStatus() {
        if (!this.line?.accountableAccount?.name) {
            return "";
        }
        const aaName = this.line?.accountableAccount.name;
        if (this.$store.state.accountableAccountTable) {
            const dbAA = this.$store.state.accountableAccountTable.accountableAccounts.find(
                (aa) => aa.name === aaName,
            );
            if (dbAA?.lettering) {
                const excludedForPaymentAccountableAccounts = [/^589999/i];
                for (const excludedForPaymentAccountableAccount of excludedForPaymentAccountableAccounts) {
                    if (aaName.match(excludedForPaymentAccountableAccount)) {
                        return "";
                    }
                }

                if (this.line?.reconciliation) {
                    return "DONE";
                }
                return "TODO";
            }
        }
        return "";
    }

    focusOnDateOrWording() {
        if (this.accountableAccount.name.startsWith("401")) {
            if (this.autoCompletion) {
                this.$emit("focus-on-date");
            } else {
                this.$emit("focus-on-wording");
            }
        } else {
            this.$emit("focus-on-wording");
        }
    }

    beforeMount() {
        if (this.line?.tags?.length) {
            this.displayFreeTag = true;
        }
    }

    @Emit("item-wording-changed")
    onItemWordingChanged() {
        // the first line is the referent for the others but each can have a different wording
        if (this.onAccountingLinesPage && this.index === 0) {
            this.$emit("on-first-line-wording-change", this.line.wording);
        }
        return this.line;
    }

    @Emit("item-debit-changed")
    onItemDebitChanged() {
        this.line.credit = 0;
        return this.line;
    }

    @Emit("item-credit-changed")
    onItemCreditChanged() {
        this.line.debit = 0;
        return this.line;
    }

    @Emit("insert-line-after")
    insertLineAfter() {
        return this.index;
    }

    @Emit("remove-line")
    removeLine() {
        return this.index;
    }

    onAccountingLineTagsChanged(data) {
        this.line.tags = data.tags;
    }

    @Emit("due-date-changed")
    onDueDateChanged(dueDate: any) {
        return dueDate;
    }

    onAAFocus(e, clickEvent: any) {
        // console.log("onAAFocus")
        if (e) {
            if (!this.accoutableAccountIsFocused) {
                if (this.onAccountingLinesPage && this.accountableAccount.name) {
                    // no need to open the dialog if the accountable account is already filled
                    this.accoutableAccountIsFocused = true;
                } else {
                    clickEvent();
                    this.accoutableAccountIsFocused = true;
                }
            } else {
                this.accoutableAccountIsFocused = false;
            }
            this.$emit("focus", { index: this.index, field: "accountableAccount" });
        }
    }

    onFocus(field: string) {
        // console.log("onFocus", field)
        this.$emit("focus", { index: this.index, field });
    }

    onFocusField(e, field: string) {
        if (e) {
            this.onFocus(field);
        }
    }

    onTabOnCredit() {
        if (this.onAccountingLinesPage) {
            this.$emit("tab-on-credit");
        }
    }

    findElement(el) {
        if (el.localName === "input") {
            return el;
        }
        for (const child of el.children) {
            const output = this.findElement(child);
            if (output) {
                return output;
            }
        }
        return null;
    }

    getDebitCreditElement() {
        let target;
        if (this.accountableAccount?.name?.startsWith("401")) {
            // @ts-ignore
            target = this.$refs.credit.$el;
        } else if (this.accountableAccount?.name?.startsWith("6")) {
            // @ts-ignore
            target = this.$refs.debit.$el;
        } else if (this.accountableAccount?.name?.startsWith("7")) {
            // @ts-ignore
            target = this.$refs.credit.$el;
        } else if (this.accountableAccount?.name?.startsWith("411")) {
            // @ts-ignore
            target = this.$refs.debit.$el;
        } else if (this.accountableAccount?.name?.startsWith("4457")) {
            // @ts-ignore
            target = this.$refs.credit.$el;
        } else if (this.accountableAccount?.name?.startsWith("4456")) {
            // @ts-ignore
            target = this.$refs.debit.$el;
        } else if (this.accountableAccount?.name?.startsWith("4455")) {
            // @ts-ignore
            target = this.$refs.credit.$el;
        }
        return target;
    }

    previousFocus() {
        if (this.autoCompletion && this.focusedElement?.line.index === this.index) {
            if (
                this.type === "PURCHASE_INVOICE" ||
                this.type === "SALES_INVOICE" ||
                this.type === "VAT"
            ) {
                if (
                    this.focusedElement?.line.field === "addLine" ||
                    this.focusedElement?.line.field === "removeLine" ||
                    this.focusedElement?.line.field === "dueDate"
                ) {
                    const target = this.getDebitCreditElement();
                    if (target) {
                        const input = this.findElement(target);
                        if (input) {
                            input.focus();
                        }
                    }
                } else if (this.focusedElement?.line.field === "credit") {
                    let target;
                    if (this.accountableAccount?.name?.startsWith("411")) {
                        // @ts-ignore
                        target = this.$refs.debit.$el;
                    } else if (this.accountableAccount?.name?.startsWith("6")) {
                        // @ts-ignore
                        target = this.$refs.debit.$el;
                    } else if (this.accountableAccount?.name?.startsWith("4456")) {
                        // @ts-ignore
                        target = this.$refs.debit.$el;
                    }
                    if (!target && !this.accountableAccount?.name) {
                        // @ts-ignore
                        target = this.$refs.accountableAccount.$el;
                    }
                    if (target) {
                        const input = this.findElement(target);
                        // setTimeout(() => {
                        if (input) {
                            input.focus();
                        }
                        // })
                    } else {
                        this.$emit("previousLine", this.index);
                    }
                } else if (this.focusedElement?.line.field === "wording") {
                    if (this.accountableAccount?.name) {
                        this.$emit("previousLine", this.index);
                    }
                } else {
                    this.$emit("previousLine", this.index);
                }
            }
        }
    }

    nextFocus() {
        if (this.autoCompletion && this.focusedElement?.line.index === this.index) {
            if (
                this.type === "PURCHASE_INVOICE" ||
                this.type === "SALES_INVOICE" ||
                this.type === "VAT"
            ) {
                if (
                    this.focusedElement?.line?.field === "accountableAccount" ||
                    this.focusedElement?.line?.field === "wording"
                ) {
                    const target = this.getDebitCreditElement();
                    if (target) {
                        const input = this.findElement(target);
                        if (input) {
                            input.focus();
                        }
                    }
                } else if (this.focusedElement?.line.field === "debit") {
                    let target;
                    if (this.accountableAccount?.name?.startsWith("401")) {
                        // @ts-ignore
                        target = this.$refs.credit.$el;
                    } else if (this.accountableAccount?.name?.startsWith("7")) {
                        // @ts-ignore
                        target = this.$refs.credit.$el;
                    } else if (this.accountableAccount?.name?.startsWith("4457")) {
                        // @ts-ignore
                        target = this.$refs.credit.$el;
                    }
                    if (target) {
                        const input = this.findElement(target);
                        // setTimeout(() => {
                        if (input) {
                            input.focus();
                        }
                        // })
                    } else {
                        this.$emit("nextLine", this.index);
                    }
                } else {
                    this.$emit("nextLine", this.index);
                }
            }
        }
    }
}

export default toNative(AccountingItemEditionLine);
</script>
